// -------------- REMINDER Page --------------
export const REMINDER_FIELD_ERROR       = 'REMINDER_FIELD_ERROR';
export const REMINDER_FIELD_RESET_ERROR = 'REMINDER_FIELD_RESET_ERROR';
export const REMINDER_SET_ALL           = 'REMINDER_SET_ALL';
export const REMINDER_SET_ALL_FOR_EXCEL = 'REMINDER_SET_ALL_FOR_EXCEL';



// --------- REMINDER Page ---------
export function reminderFieldError(field, fieldData = {}) {
    return { type: REMINDER_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function reminderFieldResetError(field, fieldData = {}) {
    return { type: REMINDER_FIELD_RESET_ERROR }
}
export function reminderSetList(all) {
    return { type: REMINDER_SET_ALL, data: all }
}
export function reminderSetListForExcel(all) {
    return { type: REMINDER_SET_ALL_FOR_EXCEL, data: all }
}
